import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
  Modal,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import {
  getAllVehiclesDetails,
  getHubName,
  getVehicleManufacturer,
  getVehicleManufacturerModel,
  getVendorsList,
  getVehicleManufacturerModelVariant,
} from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import { Divide, Upload } from "lucide-react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const workOrderSchema = z.object({
  city: z.string().min(1, "City is required"),
  hub: z
    .number()
    .nullable()
    .refine((v) => v !== null, { message: "Hub is required" }),

  vehicle: z
    .object({
      id: z.number(),
      vehcileNo: z.string().min(10, "Vehicle No should be 10 characters"),
    })
    .or(z.string())
    .nullable(),

  vehiclename: z.string().min(1, "Vehicle Name is required"),
  vehiclemanufacturer: z.string().min(1, "Vehicle Manufacturer is required"),
  vehiclemodel: z.string().min(1, "Vehicle Model is required"),
  vehiclevariant: z.string().min(1, "Vehicle Variant is required"),
  vehicletype: z.number().min(1, "Vehicle Type is required"),
  isAssociateVehicle: z.string().min(1, "Vehicle Type is required"),
});

export default function Createbewvehicle({ setActiveItem }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const [activeStep, setActiveStep] = useState(0);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  const vehicleTypeList = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;
  const [vehicleManufacturer, setVehicleManufacturer] = useState(null);
  const [vehicleModel, setVehicleModel] = useState(null);
  const [vehicleVariant, setVehicleVariant] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [editType, setEditType] = useState("");
  const [selectFieldType, setSelectFieldType] = useState(null);
  const [form, setForm] = useState({});
  const [dropdownSelectedCar, setDrodownSelectedCar] = useState(false);

  const inputFields = {
    Manufacturer: [
      {
        label: "Manufacturer Name",
        value: "manufacturernameinput",
        type: "text",
        disabled: false,
        required: true,
      },
      {
        label: "Manufacturer Code",
        value: "manufacturercodeinput",
        type: "text",
        disabled: false,
        required: true,
      },
    ],

    Model: [
      {
        label: "Vehicle Model Name",
        value: "vehiclemodalnameinput",
        type: "text",
        disabled: false,
        required: true,
      },
      {
        label: "Vehicle Model Code",
        value: "vehiclemodalcodeinput",
        type: "text",
        disabled: false,
        required: true,
      },
      {
        label: "Vehicle Manufacturer",
        value: "vehiclemanufacturerinput",
        type: "text",
        disabled: true,
        required: true,
      },
    ],

    Variant: [
      {
        label: "Variant Name",
        value: "variantnameinput",
        type: "text",
        disabled: false,
        required: true,
      },
      {
        label: "Variant Code",
        value: "variantcodeinput",
        type: "text",
        disabled: false,
        required: true,
      },
      {
        label: "Vehicle Manufacturer",
        value: "vehiclemanufacturerinput",
        type: "dropdown",
        disabled: true,
        required: true,
        subCategory:
          vehicleManufacturer &&
          Object.entries(vehicleManufacturer).map(([key, value]) => ({
            label: value,
            value: key,
          })),
      },
      {
        label: "Vehicle Model",
        value: "vehiclemodelinput",
        type: "dropdown",
        disabled: true,
        required: true,
        subCategory:
          vehicleModel &&
          Object.entries(vehicleModel).map(([key, value]) => ({
            label: value,
            value: key,
          })),
      },
    ],
  };

  useEffect(() => {
    setSelectFieldType(inputFields[editType] || []);
  }, [editType, vehicleManufacturer, vehicleModel]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(workOrderSchema),
    defaultValues: {
      city: "",
      hub: null,
      vehicle: null,
      vehiclename: "",
      vehiclemanufacturer: "",
      vehiclemodel: "",
      vehiclevariant: "",
      vehicletype: "",
      isAssociateVehicle: ""
    },
  });

  const values = watch();

  const onSubmit = async (data) => {
    let payload = {
      cityId: data?.city,
      hubId: data?.hub,
      name: data?.vehiclename,
      licensePlate: data?.vehicle,
      status: vehicleStatus?.inverted?.inactive,
      cityText: cities[data?.city],
      vehicleMake: data?.vehiclemanufacturer,
      vehicleMakeText: vehicleManufacturer[data?.vehiclemanufacturer],
      vehicleModel: data?.vehiclemodel,
      vehicleModelText: vehicleModel[data?.vehiclemodel],
      vehicleVariantText: vehicleVariant[data?.vehiclevariant],
      vehicleVariant: data?.vehiclevariant,
      vehicleType: data?.vehicletype,
      vehicleTypeText: vehicleTypeList?.[data?.vehicletype],
      isAssociateVehicle: data?.isAssociateVehicle
    };
    try {
      const response = await fetch(`${apiUrl}/api/vehicles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        toast.success("New Vehicle Created Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setActiveItem("View all Vehicles");
      } else {
        toast.error(data?.msg || data?.message);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const ImageHandler = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const urls = res?.uploaded?.map((img) => img.url) || [];

    setUploadedImages((prev) => [...prev, ...urls]);
    return urls;
  };

  const getHubAPI = async (cityId) => {
    const apiDetails = await getHubName(cityId);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const getVehicleListingAPI = async () => {
    const apiDetails = await getAllVehiclesDetails();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleList(data?.entities?.rows || []);
  };

  const getVendorListAPI = async () => {
    const apiDetails = await getVendorsList();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendorList(data?.entities?.rows || []);
  };

  const getVehicleManufacturerAPI = async () => {
    const apiDetails = await getVehicleManufacturer();
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleManufacturer(data);
  };

  const getVehicleManufacturerModalAPI = async (maunfacturerID) => {
    const apiDetails = await getVehicleManufacturerModel(maunfacturerID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleModel(data);
  };

  const getVehicleManufacturerModalVariantAPI = async (maunfacturerID) => {
    const apiDetails = await getVehicleManufacturerModelVariant(maunfacturerID);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVehicleVariant(data);
  };

  useEffect(() => {
    if (values?.city) getHubAPI(values.city);
  }, [values?.city]);

  useEffect(() => {
    getVehicleListingAPI();
    getVehicleManufacturerAPI();
  }, []);

  useEffect(() => {
    if (values?.vehiclemanufacturer) {
      getVehicleManufacturerModalAPI(values?.vehiclemanufacturer);
    }
  }, [values?.vehiclemanufacturer]);

  useEffect(() => {
    if (values?.vehiclemodel) {
      getVehicleManufacturerModalVariantAPI(values?.vehiclemodel);
    }
  }, [values?.vehiclemodel]);

  const createnewvehiclefields = [
    {
      label: "City",
      value: "city",
      type: "select",
      subCategory:
        cities &&
        Object.entries(cities).map(([key, value]) => ({
          label: value,
          value: key,
        })),
      text: null,
    },
    {
      label: "Hub",
      value: "hub",
      type: "dropdown",
      subCategory:
        hubs &&
        Object.entries(hubs).map(([id, item]) => ({
          value: item?.id,
          label: item?.hubName,
        })),
      text: null,
    },
    {
      label: "Search By Registration No",
      value: "vehicle",
      type: "autocomplete",
      subCategory: vehicleList.map((item) => ({
        label: item?.licensePlate,
        value: { id: item?.id, vehcileNo: item?.licensePlate },
      })),
    },
    {
      label: "Vehicle Name",
      value: "vehiclename",
      type: "text",
    },
    {
      label: "Is Associate Vehicle",
      value: "isAssociateVehicle",
      type: "dropdown",
      subCategory: [
        { label: "Yes", value: "1" },
        { label: "No", value: "0" },
      ],
    },
    {
      label: "Vehicle Manufacturer",
      value: "vehiclemanufacturer",
      type: "dropdown",
      subCategory:
        vehicleManufacturer &&
        Object.entries(vehicleManufacturer).map(([key, value]) => ({
          label: value,
          value: key,
        })),
      text: (
        <>
          <span className="text-xs text-gray-500">
            <button
              onClick={() => {
                setOpenModal(true);
                setEditType("Manufacturer");
              }}
            >
              Click Me
            </button>{" "}
            to add new manufacturer
          </span>
        </>
      ),
    },
    {
      label: "Vehicle Model",
      value: "vehiclemodel",
      type: "dropdown",
      subCategory:
        vehicleModel &&
        Object.entries(vehicleModel).map(([key, value]) => ({
          label: value,
          value: key,
        })),
      text: (
        <>
          <span className="text-xs text-gray-500">
            <button
              onClick={() => {
                if (values?.vehiclemanufacturer) {
                  setForm((prev) => ({
                    ...prev,
                    vehiclemanufacturerinputText: values?.vehiclemanufacturer,
                    vehiclemanufacturerinput:
                      vehicleManufacturer[values?.vehiclemanufacturer],
                  }));
                  setOpenModal(true);
                  setEditType("Model");
                } else {
                  toast.error("Select Manufacturer First");
                }
              }}
            >
              Click Me
            </button>{" "}
            to add new model
          </span>
        </>
      ),
    },
    {
      label: "Vehicle Variant",
      value: "vehiclevariant",
      type: "dropdown",
      subCategory:
        vehicleVariant &&
        Object.entries(vehicleVariant).map(([key, value]) => ({
          label: value,
          value: key,
        })),
      text: (
        <>
          <span className="text-xs text-gray-500">
            <button
              onClick={() => {
                if (values?.vehiclemodel) {
                  setForm((prev) => ({
                    ...prev,
                    vehiclemanufacturerinputText:
                      vehicleManufacturer[values?.vehiclemanufacturer],
                    vehiclemodelinputText: vehicleModel[values?.vehiclemodel],
                    vehiclemanufacturerinput: values?.vehiclemanufacturer,
                    vehiclemodelinput: values?.vehiclemodel,
                  }));
                  setOpenModal(true);
                  setEditType("Variant");
                } else {
                  toast.error("Select Model First");
                }
              }}
            >
              Click Me
            </button>{" "}
            to add new variant
          </span>
        </>
      ),
    },
    {
      label: "Vehicle Type",
      value: "vehicletype",
      type: "dropdown",
      subCategory:
        vehicleTypeList &&
        Object.entries(vehicleTypeList)
          .filter(
            ([key, value]) => key !== "inverted" && value !== "Bike"
          )
          .map(([key, value]) => ({
            label: value,
            value: Number(key),
          }))
    },
  ];

  const renderField = (field) => {
    if (field.type === "text") {
      return (
        <>
          <Controller
            name={field.value}
            control={control}
            render={({ field: rhf }) => (
              <TextField
                {...rhf}
                size="small"
                fullWidth
                error={!!errors[field.value]}
                helperText={errors[field.value]?.message}
              />
            )}
          />
          <>{field?.text}</>
        </>
      );
    }

    if (field?.type === "select" || field?.type === "dropdown") {
      return (
        <>
          <Controller
            name={field.value}
            control={control}
            render={({ field: rhf }) => (
              <TextField
                {...rhf}
                select
                fullWidth
                size="small"
                error={!!errors[field.value]}
                helperText={errors[field.value]?.message}
              >
                {field.subCategory?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
          <>{field?.text}</>
        </>
      );
    }

    if (field.type === "autocomplete") {
      return (
        <>
          <Controller
            name={field.value}
            control={control}
            render={({ field: rhf }) => (
              <Autocomplete
                freeSolo
                options={field.subCategory || []}
                getOptionLabel={(option) => {
                  // when option is typed string
                  if (typeof option === "string") return option;
                  return option.label || "";
                }}
                value={
                  typeof rhf.value === "string"
                    ? rhf.value
                    : field.subCategory?.find(
                      (opt) => opt.value?.id === rhf.value?.id,
                    ) || null
                }
                onChange={(_, value) => {
                  // dropdown selected
                  if (typeof value === "string") {
                    rhf.onChange(value);
                  } else {
                    rhf.onChange(value?.value || "");
                    setDrodownSelectedCar(true);
                  }
                }}
                onInputChange={(_, value, reason) => {
                  // user typing
                  if (reason === "input") {
                    rhf.onChange(value);
                    setDrodownSelectedCar(false);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    error={!!errors[field.value]}
                    helperText={errors[field.value]?.message}
                    placeholder="Search or type vehicle number"
                  />
                )}
              />
            )}
          />
          <>{field?.text}</>
        </>
      );
    }

    return null;
  };

  const steps = [
    {
      label: "Create New Vehicle",
      content: (
        <div className="mt-2 p-8">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {createnewvehiclefields.map((field, idx) => (
                <div key={idx}>
                  <label className="block mb-1 font-semibold">
                    {field.label}
                  </label>
                  {renderField(field)}
                </div>
              ))}
            </div>

            <Button
              disabled={dropdownSelectedCar}
              type="submit"
              variant="contained"
              sx={{ mt: 3 }}
            >
              Submit
            </Button>
          </form>

          {uploadedImages.length > 0 && (
            <div className="mt-6 flex gap-4 flex-wrap">
              {uploadedImages.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  className="w-28 h-28 rounded border object-cover"
                />
              ))}
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setForm({});
    setOpenModal(false);
  };

  const handleSave = async () => {
    let payload;
    let apiurl;

    if (editType === "Manufacturer") {
      apiurl = "vehicle-make";
      payload = {
        name: form?.manufacturernameinput,
        code: form?.manufacturercodeinput,
      };
    } else if (editType === "Model") {
      apiurl = "vehicle-model";
      payload = {
        name: form?.vehiclemodalnameinput,
        code: form?.vehiclemodalcodeinput,
        vehicleManufacturer: form?.vehiclemanufacturerinputText,
        vehicleManufacturerText: form?.vehiclemanufacturerinput,
      };
    } else if (editType === "Variant") {
      apiurl = "vehicle-variants";
      payload = {
        name: form?.variantnameinput,
        code: form?.variantcodeinput,
        vehicleManufacturer: form?.vehiclemanufacturerinput,
        vehicleManufacturerText: form?.vehiclemanufacturerinputText,
        vehicleModel: form?.vehiclemodelinput,
        vehicleModelText: form?.vehiclemodelinputText,
      };
    }
    // return;

    try {
      const response = await fetch(`${apiUrl}/api/${apiurl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        if (editType === "Manufacturer") {
          await getVehicleManufacturerAPI();
        } else if (editType === "Model") {
          await getVehicleManufacturerModalAPI(values?.vehiclemanufacturer);
        } else if (editType === "Variant") {
          await getVehicleManufacturerModalVariantAPI(values?.vehiclemodel);
        }
        setOpenModal(false);
        toast.success("Created Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle creation:", error);
    }
  };

  const handleChange = async (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <>
      {openModal && (
        <Modal
          open={openModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="flex justify-between font-semibold">
              <h1>Add {editType}</h1>
              <button
                onClick={() => {
                  setOpenModal(false);
                  setForm({});
                }}
              >
                X
              </button>
            </div>
            {/* <div > */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-4">
              {selectFieldType.map((field, index) => (
                <>
                  <div key={index} className="group">
                    <label className="block mb-2 font-semibold text-gray-700 text-sm">
                      {field.label}
                      {field.required && (
                        <span className="text-red-500 ml-1">*</span>
                      )}
                    </label>

                    {field.type === "dropdown" ? (
                      <div className="w-full">
                        <label
                          htmlFor={field.value}
                          className="block mb-1 text-sm font-medium text-gray-700"
                        >
                          {field.label}
                        </label>

                        <select
                          id={field.value}
                          value={form[field.value] || ""}
                          onChange={(e) =>
                            handleChange(field.value, e.target.value)
                          }
                          className="
      w-full
      rounded-lg
      border
      border-gray-300
      px-3
      py-2
      text-sm
      focus:outline-none
      focus:ring-2
      focus:ring-indigo-500
      focus:border-indigo-500
    "
                        >
                          <option value="">Select {field.label}</option>

                          {field?.subCategory
                            ?.filter((opt) => opt.item !== "inverted")
                            .map((option, idx) => (
                              <option key={idx} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : (
                      <input
                        disabled={field.disabled}
                        type={field.type}
                        required={field?.required}
                        value={form[field.value] || ""}
                        onChange={(e) =>
                          handleChange(field.value, e.target.value)
                        }
                        className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${field.disabled
                            ? "bg-gray-100 cursor-not-allowed"
                            : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                          } outline-none`}
                        placeholder={`Enter ${field.label.toLowerCase()}`}
                      />
                    )}
                  </div>
                </>
              ))}
              <Button
                onClick={() => {
                  handleSave();
                }}
                type="submit"
                variant="contained"
                sx={{ mt: 3 }}
              >
                Save
              </Button>
            </div>
            {/* </div> */}
          </Box>
        </Modal>
      )}
      <div className="p-4 bg-white mt-4">
        <Box sx={{ p: 3 }}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((step) => (
              <Step key={step.label}>
                <StepLabel>
                  <Typography variant="h6">{step.label}</Typography>
                </StepLabel>

                <StepContent>
                  <Box
                    sx={{
                      mt: 1,
                      p: 3,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
                      border: "1px solid #e5e7eb",
                    }}
                  >
                    {step.content}
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>
      </div>
    </>
  );
}
